<template>
  <v-dialog
    v-model="dialog"
    :fullscreen="is_mobile"
    :scrollable="false"
    overlay-opacity="50"
    max-width="720px"
    content-class="default-dialog"
  >
    <template v-slot:activator="{}">
      <v-tooltip right>
        <template v-slot:activator="{ on }">
          <v-btn
            v-on="on"
            icon
            medium
            @click.stop="dialog = true"
            :disabled="get_interface.loading"
          >
            <v-icon medium>mdi-printer</v-icon>
          </v-btn>
        </template>
        <span>{{ lang.catalog.print_pdf }}</span>
      </v-tooltip>
    </template>
    <v-card class="default-dialog-card list-dialog-card">
      <v-card-title>
        <span class="headline">
          <v-icon>mdi-printer</v-icon>
          {{ lang.catalog.print }}
        </span>
        <v-spacer></v-spacer>
        <v-icon class="dialog-close-btn" @click="dialog = false">mdi-close</v-icon>
      </v-card-title>
      <v-card-text class="pt-1">
        <v-container
          class="overflow-y-auto dialog-scrollbar"
          v-bar="{ preventParentScroll: true, scrollThrottle: 30, resizeRefresh: true }"
        >
          <div class="print-page">
            <v-row class="print-toolbar">
              <div class="btn-wrap">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      icon
                      medium
                      @click.stop="savePDF()"
                      :disabled="get_interface.loading"
                    >
                      <v-icon medium>mdi-file-pdf-box</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ lang.catalog.pdf }}</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      icon
                      medium
                      @click.stop="savePDF(true)"
                      :disabled="get_interface.loading"
                    >
                      <v-icon medium>mdi-printer</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ lang.catalog.print }}</span>
                </v-tooltip>
              </div>
            </v-row>
            <v-row fluid class="pa-4">
              <table ref="printable" class="printable-table" style="width: 700px !important; border-radius: 7px; border: 1px solid #f2f2f2; font-size: 12px !important;">
                <tr style="background: #fcfcfc; border-bottom: 1px solid #f2f2f2;">
                  <th style="width: 10%; padding: 4px 0px; border-right: 1px solid #f2f2f2;">#ID</th>
                  <th style="width: 35%; padding: 4px 0px; border-right: 1px solid #f2f2f2;">Categoria</th>
                  <th style="width: 35%; padding: 4px 0px; border-right: 1px solid #f2f2f2;">Título</th>
                  <th style="width: 10%; padding: 4px 0px; border-right: 1px solid #f2f2f2;">Estoque</th>
                  <th style="width: 10%; padding: 4px 0px; border-right: 1px solid #f2f2f2;">Preço</th>
                </tr>
                <tr
                  v-for="(item, i) in data"
                  :key="i"
                  style="border-bottom: 1px solid #f2f2f2;"
                >
                  <td style="padding: 4px; border-right: 1px solid #f2f2f2;">{{ item.id }}</td>
                  <td style="padding: 4px; border-right: 1px solid #f2f2f2;">{{ (item.parent_cat === 0 ? lang.categories.new.no_one : `${item.parent_cat_name}${(item.cat !== item.parent_cat ? ' > ' + item.cat_name : '')}`) }}</td>
                  <td style="padding: 4px; border-right: 1px solid #f2f2f2;">{{ item.title }}</td>
                  <td style="padding: 4px; border-right: 1px solid #f2f2f2;">{{ (item.stock > 0 ? item.qty : lang.catalog.stock.disab )}}</td>
                  <td style="padding: 4px;">{{ formatCurrency(item.price) }}</td>
                </tr>
              </table>
            </v-row>
          </div>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import appdata from '@/mixins/appdata'
import utils from '@/mixins/utils'

import jsPDF from 'jspdf'

export default {
  mixins: [ appdata, utils ],
  props: {
    catalog: {
      type: String,
      required: true
    }
  },
  data: () => ({
    dialog: false
  }),
  computed: {
    data () {
      const catalog = this.get_data.catalog || []
      return catalog
        .filter(cat => cat.catalog === this.catalog)
        .sort((a, b) => a.cat - b.cat) || []
    }
  },
  methods: {
    savePDF (print = false) {
      const el = this.$refs.printable,
            // eslint-disable-next-line no-unused-vars
            options = {
              // type: 'dataURL',
              dpi: 300,
              scale: 1
            }
      /* var HTML_Width = el.clientWidth,
          HTML_Height = el.clientHeight,
          top_left_margin = 15,
          PDF_Width = HTML_Width + (top_left_margin * 2),
          PDF_Height = (PDF_Width * 1.5) + (top_left_margin * 2),
          canvas_image_width = HTML_Width,
          canvas_image_height = HTML_Height,
          totalPDFPages = Math.ceil(HTML_Height / PDF_Height) - 1

      this.$html2canvas(el, options).then(imgData => {
        var pdf = new jsPDF('p', 'pt', [ PDF_Width, PDF_Height ])
        pdf.addImage(imgData, 'JPG', top_left_margin, top_left_margin, canvas_image_width, canvas_image_height)
        for (var i = 1; i <= totalPDFPages; i++) {
            let position = - (PDF_Height * i) + (top_left_margin * 4)
            pdf.addPage(PDF_Width, PDF_Height)
            pdf.addImage(imgData, 'PNG', top_left_margin, position, canvas_image_width, canvas_image_height)
        }
        pdf.save("catalogo.pdf")
      }) */
      // 2
      this.$html2canvas(el, options).then(canvas => {
        var imgWidth = 210,
            pageHeight = 290,
            left_margin = 8,
            top_margin = 9,
            imgHeight = (canvas.height * imgWidth / canvas.width),
            heightLeft = imgHeight

        var doc = new jsPDF('p', 'mm', 'a4'),
            position = 0,
            pageData = canvas.toDataURL('image/jpeg', 1.0),
            imgData = encodeURIComponent(pageData)

        doc.addImage(imgData, 'PNG', left_margin, top_margin, imgWidth - (2 * left_margin), imgHeight)
        doc.setLineWidth(14);
        doc.setDrawColor(255, 255, 255);
        doc.rect(0, 2, 210, 293);
        heightLeft -= pageHeight

        while (heightLeft >= 0) {
          position = (heightLeft - imgHeight) + (top_margin * 2)
          doc.addPage()
          doc.addImage(imgData, 'PNG', left_margin, position, imgWidth - (2 * left_margin), imgHeight)
          doc.setLineWidth(14);
          doc.setDrawColor(255, 255, 255);
          doc.rect(0, 2, 210, 293);
          heightLeft -= pageHeight - (top_margin + 2)
        }
        if (print) {
          doc.autoPrint();
          doc.output('dataurlnewwindow');
        } else {
          doc.save('catalogo.pdf')
        }
      })
    }
  }
}
</script>

<style lang="scss">
#app .print-page {
  .print-toolbar {
    padding: 0 7px;
    .btn-wrap {
      margin-left: auto !important;
    }
  }
  .printable-table {
    height: auto;
    background-color: #fff;
  }
}
</style>